import { Injectable } from '@angular/core';
import { ContactApi } from './contact.api';

@Injectable({
	providedIn: 'root'
})
export class ContactService {

	constructor(
		private api: ContactApi,
	) { }

	public sendContact (
		name: string,
		email: string,
		message: string,
		subject?: string
	) {
		if(!subject) subject = "Nova mensagem do formulário de contato";
		return this.api.postContact(name, email, subject, message);
	}

}
